import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { URL } from "../../../constants/URL";
import { useGetEmails } from "../../../queryHooks";
import BreadCrumbs from "../../common/breadcrumbs";
import SearchBox from "../../common/searchBox";
import qs from "qs";
import { Link } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import Icon from "../../icons/index";
import Table from "../../common/table";
import { useStore } from "../../../zustand/store";
import { modules } from "../../../constants/Modules";

//	Pre-defined values
const columnKey = "emailTemplates";

//	Component starts
const EmailTemplates = () => {
	//	Navigation
	const navigate = useNavigate();
	const lastPageData = useStore((state) => state.lastPageData);
	const setLastPageData = useStore((state) => state.setLastPageData);
	const [pageNow, setPageNow] = useState(
		lastPageData?.[modules.EMAIL_TEMPLATE]?.page || 1
	);
	const [itemsPerPage, setItemsPerPage] = useState(
		lastPageData?.[modules.EMAIL_TEMPLATE]?.items_per_page || 10
	);
	const [tableData, setTableData] = useState();
	const [emailTemplateListPayload, setEmailTemplateListPayload] = useState(
		lastPageData?.[modules.EMAIL_TEMPLATE] || {
			pagination: true,
			items_per_page: itemsPerPage,
			page: pageNow,
			sort: {
				"emails.label": "ASC",
			},
		}
	);
	/******************************************************************************************
	@Purpose    :   To get the Email templates list
	*******************************************************************************************/

	const columns = [
		{
			label: "Email Title",
			type: "string",
			sort: true,
			path: "label",
			alias: "emails.label",
			content: (item) => (
				<Link
					to={`${URL.emailTemplates}/${item?.id}`}
					onClick={() => {
						setLastPageData({
							[modules.EMAIL_TEMPLATE]: emailTemplateListPayload,
						});
					}}
				>
					{item.label}
				</Link>
			),
		},
		{
			label: "Email Key",
			type: "string",
			sort: false,
			path: "code",
		},
		{
			label: "Subject",
			type: "string",
			sort: false,
			path: "email_subject",
		},
		{
			label: "Action",
			type: "boolean",
			content: (item) => (
				<>
					<Icon
						type="edit"
						data-tip
						data-for="edit"
						onClick={() => {
							setLastPageData({
								[modules.EMAIL_TEMPLATE]: emailTemplateListPayload,
							});
							navigate(`${URL.emailTemplates}/${item?.id}`);
						}}
					/>
					<ReactTooltip id="edit" place="top" effect="solid">
						Edit
					</ReactTooltip>
					{/* <Icon
						type="delete"
						data-tip
						data-for="delete"
						onClick={() => handleDelete([item._id])}
					/>
					<ReactTooltip id="delete" place="top" effect="solid">
						Delete
					</ReactTooltip> */}
				</>
			),
		},
	];

	const { data: emailTemplateList, isLoading: emailDataLoading } = useGetEmails(
		qs.stringify(emailTemplateListPayload)
	);

	useEffect(() => {
		if (emailTemplateList) {
			if (emailTemplateList?.status === "success") {
				let respData = emailTemplateList?.data;
				respData.page = pageNow;
				respData.items_per_page = itemsPerPage;
				setTableData(respData);
			}
		}
	}, [emailTemplateList]);

	return (
		<>
			<BreadCrumbs
				title="Email Templates"
				data={[{ label: "Email Templates" }]}
			/>
			<div className="dataTables_wrapper">
				<div className="content-area position-relative">
					<div className="grid">
						<div className="grid-content">
							<div className="user-listing-filterOptions mb-2 mt-3 d-block">
								<div className="row mb-2">
									<div className="col-sm-8 mb-2 position-static">
										<div className="left-buttons d-flex">
											<SearchBox
												columnKey={columnKey}
												searchValue={
													lastPageData?.[modules.EMAIL_TEMPLATE]?.search?.[
														"emails.label"
													]
												}
												search={(value) => {
													setPageNow(1);
													setEmailTemplateListPayload({
														...emailTemplateListPayload,
														search: {
															"emails.label":
																!value && value === "" ? undefined : value,
															"emails.email_body":
																!value && value === "" ? undefined : value,
															"emails.email_subject":
																!value && value === "" ? undefined : value,
														},
														page: 1,
													});
												}}
											/>
										</div>
									</div>
									{/* <div className="col-sm-4">
										<div className="right-buttons d-flex justify-content-end">
											<button
												onClick={() => navigate(`${URL.emailTemplates}/add`)}
												type="button"
												className="btn glow-primary btn-primary"
											>
												<span className="bx bx-user-plus d-lg-none"></span>
												<span className="d-none d-sm-none d-lg-inline-block">
													Add Email Template
												</span>
											</button>
										</div>
									</div> */}
								</div>
							</div>
							<Table
								columnKey={columnKey}
								columns={columns}
								tableData={tableData}
								loading={emailDataLoading}
								payload={emailTemplateListPayload}
								sortCol={(obj) => {
									setPageNow(1);
									setEmailTemplateListPayload({
										...emailTemplateListPayload,
										sort: {
											[obj.alias]:
												!obj.sort && obj.sort === "" ? undefined : obj.sort,
										},
										page: 1,
									});
								}}
								setCurrentPage={(page) => {
									setPageNow(page);
									setEmailTemplateListPayload({
										...emailTemplateListPayload,
										page,
									});
								}}
								setCurrentLimit={(items_per_page) => {
									setPageNow(1);
									setItemsPerPage(items_per_page);
									setEmailTemplateListPayload({
										...emailTemplateListPayload,
										items_per_page,
										page: 1,
									});
								}}
							/>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default EmailTemplates;
